const PageCollege = () => import('@/modules/college/PageCollege')

export default [
  {
    path: '/college',
    name: 'college',
    component: PageCollege,
    meta: {
      title: '双创学院',
      needLogin: true,
      isBlack: true
    },
  },

]
